export default {
  stepContent: {
    id: 'report_illicit_content_step_content',
    defaultMessage: 'The illicit content',
  },
  stepAbout: {
    id: 'report_illicit_content_step_about',
    defaultMessage: 'Your details',
  },
  stepDeclaration: {
    id: 'report_illicit_content_step_declaration',
    defaultMessage: 'Declaration',
  },
}
